import type { ReactNode } from 'react';
import classnames from 'classnames';

interface IContainerProps {
    children: ReactNode;
    isFluid?: boolean;
    isFluidOnMobile?: boolean;
}

export function Container(props: IContainerProps) {
    const className = classnames('container', {
        'is-fluid': props.isFluid,
        'is-fluid-on-mobile': props.isFluidOnMobile,
    });

    return <div className={className}>{props.children}</div>;
}
